export const valuationDeviationMetrics = {
  error: 'error',
  mape: 'mape',
  mse: 'mse'
} as const

export type ValuationDeviationMetric = keyof typeof valuationDeviationMetrics
